<template>
  <basic-container>
    <div class="page">
      <h1 class="headerStyle">
        {{ disabled ? "查看员工信息" : "编辑员工信息" }}
      </h1>
      <div
        class="page-description"
        v-for="(group, groupIndex) in result"
        :key="groupIndex"
      >
        <el-form v-if="group.manageShow == 'true'" class="form-group">
          <el-row v-if="group.manageShow == 'true'">
            <el-col :span="24">
              <div class="group-title">
                {{ group.group_name }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="group.manageShow == 'true'">
            <el-col
              v-for="(field, fieldIndex) in group.field_meta_info_list"
              :key="fieldIndex"
              :span="12"
            >
              <div v-if="field.fieldType != 'NONE'" class="field-text">
                {{ field.field_name }}
              </div>
              <!-- 处理不同字段类型 -->
              <template v-if="field.fieldType === 'NONE'"></template>
              <template v-if="field.fieldType === 'TextField'">
                <el-input
                  clearable
                  :disabled="disabled"
                  type="text"
                  v-model="result[groupIndex][field.id]"
                  placeholder="请输入"
                  @input="
                    handleInputChange(
                      groupIndex,
                      field.id,
                      result[groupIndex][field.id]
                    )
                  "
                  class="field-input"
                />
              </template>
              <template v-else-if="field.fieldType === 'DDSelectField'">
                <el-select
                  clearable
                  :disabled="disabled"
                  v-model="result[groupIndex][field.id]"
                  placeholder="请选择"
                  @change="
                    handleInputChange(
                      groupIndex,
                      field.id,
                      result[groupIndex][field.id]
                    )
                  "
                >
                  <el-option
                    :disabled="disabled"
                    v-for="(item, index) in JSON.parse(field.option_text)"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
              <!-- 部门el-Cascader级联选择器 -->
              <template v-else-if="field.fieldType === 'DDTreeField'">
                <el-cascader
                  clearable
                  v-model="result[groupIndex][field.id]"
                  :options="JSON.parse(field.option_text)"
                  placeholder="请选择"
                  change-on-select
                  filterable
                  :disabled="disabled"
                  @change="
                    handleTreeChange(
                      groupIndex,
                      field.id,
                      result[groupIndex][field.id]
                    )
                  "
                ></el-cascader>
              </template>
              <template
                v-else-if="
                  field.fieldType === 'DDDateField' ||
                    field.fieldType === 'DDDateWithLongField'
                "
              >
                <el-date-picker
                  clearable
                  v-if="field.fieldType === 'DDDateField'"
                  v-model="result[groupIndex][field.id]"
                  type="date"
                  :disabled="disabled"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  @change="
                    handleInputChange(
                      groupIndex,
                      field.id,
                      result[groupIndex][field.id]
                    )
                  "
                ></el-date-picker>
                <el-date-picker
                  clearable
                  :disabled="disabled"
                  v-else-if="field.fieldType === 'DDDateWithLongField'"
                  v-model="result[groupIndex][field.id]"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="
                    handleInputChange(
                      groupIndex,
                      field.id,
                      result[groupIndex][field.id]
                    )
                  "
                ></el-date-picker>
              </template>
              <template v-else-if="field.fieldType === 'DDPhotoField'">
                <div class="uploadPicture">
                  <!-- 表单的图片上传到阿里云服务器,限制1张 -->
                  <el-upload
                    :disabled="disabled"
                    class="upload-demo"
                    action="#"
                    accept="image/jpeg,image/jpg,image/png"
                    :http-request="uploadFile(groupIndex, field.id)"
                    :show-file-list="false"
                  >
                    <i v-if="!field.value" class="el-icon-plus"></i>
                    <!-- 上传成功后回显 -->
                    <img
                      v-else
                      :src="field.value"
                      class="avatar"
                      style="width: 100px; height: 100px;"
                    />
                  </el-upload>
                  <!-- 否则为删除 -->
                  <i
                    v-if="field.value && disabled == false"
                    class="el-icon-delete delIcon"
                    @click="
                      handleDelChange(
                        groupIndex,
                        field.id,
                        result[groupIndex][field.id]
                      )
                    "
                  ></i>
                </div>
              </template>
            </el-col>
          </el-row>
          <el-row style="text-align: center;">
            <el-button
              :disabled="disabled"
              v-if="group.detail == 'true'"
              @click="addFieldToGroup(groupIndex)"
              class="add-button"
            >
              增加明细
            </el-button>
            <el-button
              :disabled="disabled"
              v-if="group.delShow == 'true'"
              @click="delFieldToGroup(groupIndex)"
              class="add-button"
            >
              删除明细
            </el-button>
          </el-row>
        </el-form>
      </div>
      <div class="group-box">
        <h1 v-if="disabled == true" class="headerStyle">
          员工异动信息
        </h1>
        <!-- 员工异动列表 -->
        <el-table v-if="disabled == true" :data="stuffChangeInfo" border>
          <el-table-column label="异动类型" prop="changeType"></el-table-column>
          <el-table-column label="部门名称" prop="department"></el-table-column>
          <el-table-column label="职位" prop="position"></el-table-column>
          <el-table-column label="操作人员" prop="createBy"></el-table-column>
          <el-table-column label="操作时间" prop="createTime"></el-table-column>
        </el-table>
      </div>
      <div class="footer-box">
        <el-button
          v-if="disabled == false"
          class="submit-button"
          @click="submitForm"
          >保存修改</el-button
        >
        <el-button
          v-if="disabled == true"
          class="submit-button"
          @click="returnBack"
        >
          返回
        </el-button>
      </div>
    </div>
  </basic-container>
</template>

<script>
import {
  getEditRoster,
  updateRoster,
  getStuffChangeInfo,
} from "@/api/salesCloud/stuff";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import { resolveUrlPath } from "@/util/util";
import oss from "ali-oss";
import md5 from "js-md5";
export default {
  data() {
    return {
      result: [],
      stuffChangeInfo: [],
      disabled: false,
      CHANGE_TYPE: [
        {
          label: "离职",
          value: "DISMISSION",
        },
        {
          label: "转正",
          value: "ON_JOB",
        },
        {
          label: "调岗",
          value: "TRANSFER_POSITION",
        },
        {
          label: "新入职",
          value: "NEW_RECRUITS ",
        },
      ],
    };
  },
  created() {
    this.getRosterField();
    console.log(this.$route.query.status, "this.$route.query.status");
    if (this.$route.query.status === "view") {
      this.disabled = true;
      this.getStuffChangeInfo();
    }
  },
  methods: {
    /**
     * 上传文件到阿里云服务器
     */
    uploadFile(groupIndex, fieldId) {
      return (option) => {
        // 上传文件到阿里云服务器
        getAliyunPublicToken().then((res) => {
          let data = JSON.parse(res.data);
          const client = new oss({
            region: data.point,
            endPoint: data.point,
            accessKeyId: data.accessKeyId,
            accessKeySecret: data.accessKeySecret,
            Expiration: data.expiration,
            bucket: data.bucketName,
            stsToken: data.securityToken,
          });
          const storeAs = md5(option.file.name) + new Date().getTime();

          // 查找对应的 field_meta_info_list 对象
          const fieldMetaInfo = this.result[
            groupIndex
          ].field_meta_info_list.find((field) => field.id === fieldId);
          if (!fieldMetaInfo) {
            return;
          }

          if (!fieldMetaInfo.value) {
            // 如果 value 不存在，初始化为一个空字符串
            fieldMetaInfo.value = "";
          }
          client
            .multipartUpload(storeAs, option.file, {})
            .then((results) => {
              let res = results.res.requestUrls[0].split("?");
              const imageURL = res[0];

              if (fieldMetaInfo.value) {
                // 如果 value 已经有值，表示这是多图情况
                fieldMetaInfo.value += "," + imageURL;
              } else {
                // 如果 value 为空，表示这是单图情况
                fieldMetaInfo.value = imageURL;
              }
              console.log(fieldMetaInfo.value, "fieldMetaInfo.value");
              // 添加到 field_meta_info_list[].value 数组中
              this.result[groupIndex][fieldId] = fieldMetaInfo.value;
              // 更新 fileList 以便显示上传的文件
              this.updateFileList();
            })
            .catch((err) => {
              console.error(err);
            });
        });
      };
    },
    // 更新 fileList 以便显示上传的文件
    updateFileList() {
      // 清空 fileList
      this.fileList = [];

      this.result.forEach((group) => {
        group.field_meta_info_list.forEach((field) => {
          if (field.fieldType === "DDPhotoField") {
            // 如果是图片上传控件
            if (field.value) {
              // 如果有图片 URL，拆分成数组并更新 fileList
              const imageURLs = field.value.split(",");
              imageURLs.forEach((url, index) => {
                this.fileList.push({
                  name: `Image ${index + 1}`,
                  url: url,
                });
              });
            }
          }
        });
      });
    },
    // 获取员工异动信息
    async getStuffChangeInfo() {
      let id = this.$route.query.id;
      await getStuffChangeInfo(id).then((res) => {
        if (res.code === "200") {
          let data = JSON.parse(res.data);
          data.forEach((item) => {
            item.changeType = this.CHANGE_TYPE.find(
              (type) => type.value === item.changeType
            ).label;
            // createTime转换为时间格式
            item.createTime = item.createTime = this.formatDate(item.createTime);
          });
          this.stuffChangeInfo = data;
          console.log(this.stuffChangeInfo, "this.stuffChangeInfo");
        }
      });
    },

    // 时间格式转换
    formatDate(date) {
      // eslint-disable-next-line no-redeclare
      var date = new Date(date);
      var YY = date.getFullYear() + "-";
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    // 获取员工档案字段,处理编辑回显
    getRosterField() {
      let id = this.$route.query.id;
      getEditRoster(id).then((res) => {
        if (res.code === "200") {
          let data = JSON.parse(res.data);
          let newData = [];
          data.forEach((item) => {
            if (item.detail === "true") {
              let maxValuesLength = 0;
              item.field_meta_info_list.forEach((field) => {
                if (field.value !== null) {
                  const values = field.value.split(",");
                  if (values.length > maxValuesLength) {
                    maxValuesLength = values.length;
                  }
                } else {
                  maxValuesLength = 1;
                }
              });

              for (let i = 0; i < maxValuesLength; i++) {
                const newGroup = JSON.parse(JSON.stringify(item)); // 创建深度克隆
                if (i !== 0) {
                  newGroup.group_name += i;
                }

                newGroup.field_meta_info_list.forEach((field) => {
                  if (field.value !== null) {
                    const values = field.value.split(",");
                    field.value = values[i] || ""; // 设置值或空字符串
                    newGroup[field.id] = field.value; // 在 newGroup 对象中反映更改
                  } else {
                    field.value = "";
                    newGroup[field.id] = field.value; // 在 newGroup 对象中反映更改
                  }
                });

                newData.push(JSON.parse(JSON.stringify(newGroup)));
              }
            } else {
              item.field_meta_info_list.forEach((field) => {
                // 数据回显
                if (
                  field.fieldType === "TextField" ||
                  field.fieldType === "DDSelectField"
                ) {
                  item[field.id] = field.value;
                }

                if (field.fieldType === "DDTreeField") {
                  // 如果存在 option_text，进行修改
                  if (field.option_text) {
                    var options = JSON.parse(field.option_text);
                    // 递归修改树形结构内的数据
                    options = this.changeTreeData(options);

                    field.option_text = JSON.stringify(options);
                  }
                  // el-cascader数据回显
                  if (field.value) {
                    const selectedValue = field.value.split(",");
                    const options = JSON.parse(field.option_text);
                    // 找到对应值在 options 中的完整层级结构
                    const selectedHierarchy = this.findHierarchy(
                      options,
                      selectedValue
                    );
                    // 将选择的完整层级结构赋值给 result
                    item[field.id] = selectedHierarchy;
                  }
                }
                if (field.fieldType === "DDDateField") {
                  if (field.value) {
                    item[field.id] = field.value;
                  }
                }
                if (field.fieldType === "DDDateWithLongField") {
                  if (field.value) {
                    // field.value = "2023-10-11,2024-1-20";
                    let arr = field.value.split(",");
                    item[field.id] = [arr[0], arr[1]];
                    // item[field.id] = [parseInt(arr[0]), parseInt(arr[1])];
                  }
                }
                if (field.fieldType === "DDPhotoField") {
                  if (field.value) {
                    item[field.id] = field.value;
                  }
                }
              });
              newData.push(item);
            }
          });
          this.result = newData;
        }
      });
    },

    // 递归查找值在 options 中的完整层级结构
    findHierarchy(options, targetValue) {
      let hierarchy = [];

      function findInOptions(val, arr) {
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i];
          if (item.value === val) {
            hierarchy.push(item.value);
            return true;
          } else if (item.children) {
            if (findInOptions(val, item.children)) {
              hierarchy.unshift(item.value);
              return true;
            }
          }
        }
        return false;
      }

      for (let i = 0; i < targetValue.length; i++) {
        const val = targetValue[i];
        findInOptions(val, options);
      }

      return hierarchy;
    },

    // 递归修改树形结构内的数据
    changeTreeData(data) {
      data.forEach((item) => {
        item.value = item.id;
        item.label = item.name;
        if (item.children.length == 0) {
          delete item.children;
        }
        delete item.id;
        delete item.name;
        if (item.children && item.children.length > 0) {
          this.changeTreeData(item.children);
        }
      });
      return data;
    },
    // 部门el-Cascader级联选择器，可单选选择任意一级菜单的选项
    handleTreeChange(groupIndex, fieldId, selectedValue) {
      // 处理用户选择，你可以在这里进行其他逻辑
      console.log(groupIndex, fieldId, selectedValue);
      console.log(selectedValue, "selectedValue", typeof selectedValue);
      // 将选择的值赋给对应的层级
      this.result[groupIndex][fieldId] = selectedValue;
    },
    // 处理用户输入
    handleInputChange(groupIndex, fieldCode, value) {
      console.log(groupIndex, fieldCode, value);
      // 处理用户输入，可以进行验证或其他逻辑
      this.result[groupIndex][fieldCode] = value;
    },
    handleDelChange(groupIndex, fieldId, value) {
      console.log(groupIndex, fieldId, value);
      // 获取要删除的字段组
      const group = this.result[groupIndex];

      // 查找对应的 field_meta_info_list 对象
      const fieldMetaInfo = group.field_meta_info_list.find(
        (field) => field.id === fieldId
      );

      if (fieldMetaInfo) {
        // 将 value 置为空，表示没有图片
        fieldMetaInfo.value = null;

        // 清空结果中对应字段的值
        this.result[groupIndex][fieldId] = null;

        // 使用Vue.set来更新数据以触发Vue的数据检测
        this.$set(group, fieldId, this.result[groupIndex][fieldId]);

        // 更新文件列表以便显示上传的文件
        this.updateFileList();
      }
    },

    // 添加明细
    addFieldToGroup(groupIndex) {
      // 点击的这个字段组的detail设置为false
      this.result[groupIndex].detail = "false";
      //新增一个是可新增明细的属性给字段组
      this.result[groupIndex].detailShow = "true";
      // 创建一个新字段组
      const newGroup = JSON.parse(JSON.stringify(this.result[groupIndex]));
      //新增一个是可删除当前明细的属性给字段组
      newGroup.delShow = "true";
      // 新增一个代表这个字段组是可删除的
      newGroup.Del = "true";
      // 将新的detail设置为true
      newGroup.detail = "true";

      // 递增字段组名称中的索引
      newGroup.group_name = this.getGroupNameWithIndex(newGroup.group_name);

      // 清空新字段组中的数据
      for (const field of newGroup.field_meta_info_list) {
        field.value = null;
      }

      // 添加新字段组到选择的字段组之后
      this.result.splice(groupIndex + 1, 0, newGroup);
    },
    // 删除明细
    delFieldToGroup(groupIndex) {
      if (this.result[groupIndex].Del == "true") {
        // 删除当前明细
        this.result.splice(groupIndex, 1);
        // 点击的这个字段组的detail设置为true
        this.result[groupIndex - 1].detail = "true";
        //新增一个是可新增明细的属性给字段组
        this.result[groupIndex - 1].detailShow = "true";
        //新增一个是可删除当前明细的属性给字段组
        this.result[groupIndex - 1].delShow = "true";
      } else {
        this.$message({
          message: "不可以删除啦！",
          type: "warning",
        });
      }
    },
    // 获取带有索引的字段组名称
    getGroupNameWithIndex(groupName) {
      // 从 groupName 中提取当前索引，如果没有索引则默认为 0
      const match = groupName.match(/(\d+)$/);
      let index = 1;
      if (match) {
        index = parseInt(match[1], 10) + 1;
      }

      // groupName只取前面的中文部分
      groupName = groupName.replace(/\d+$/, "");

      // 将递增的索引添加到 groupName 中
      return `${groupName}${index}`;
    },
    // 提交表单
    submitForm() {
      const validationPassed = this.validateFields(this.result);
      if (validationPassed) {
        const processedResult = {};
        const clonedResult = this.cloneResult(this.result);

        clonedResult.forEach((group) => {
          if (group.manageShow === "true") {
            group.field_meta_info_list.forEach((field) => {
              if (field.fieldType !== "NONE") {
                const { id } = field;
                const value = group[id];

                if (!processedResult[id]) {
                  processedResult[id] = { ...field, value };
                } else {
                  processedResult[id].value = processedResult[id].value
                    ? `${processedResult[id].value},${value}`
                    : value;
                }
              }
            });
          }
        });
        clonedResult.forEach((group) => {
          if (group.manageShow === "true") {
            group.field_meta_info_list.forEach((field) => {
              if (field.fieldType !== "NONE") {
                const { id } = field;
                if (processedResult[id]) {
                  field.value = processedResult[id].value;
                }
              }
              // 如果是级联选择器，将value转换为字符串并且只取最后一级的
              if (field.fieldType === "DDTreeField") {
                if (field.value && field.value.length > 0) {
                  field.value = field.value[field.value.length - 1].toString();
                } else {
                  field.value = null;
                }
              }
              //如果field.fieldType === 'DDDateWithLongField'，将value转换为字符串
              if (field.fieldType === "DDDateWithLongField") {
                if (field.value) {
                  field.value = field.value.toString();
                } else {
                  field.value = null;
                }
              }
            });
          }
          // 如果detailShow为true，将这个的detail设置为true
          if (group.detailShow) {
            group.detail = "true";
          }
        });

        const uniqueObjects = this.filterUniqueObjects(clonedResult);

        console.log(uniqueObjects);
        // 在这里添加提交数据到服务器的代码
        this.submitDataToServer(uniqueObjects);
      }
    },
    //returnBack返回上一页
    returnBack() {
      let item = {
        close: true,
        label: "编辑员工信息",
        value: "/salesCloud/stuff/edit",
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.push({
        path: resolveUrlPath("/salesCloud/stuff"),
      });
    },
    // 递归函数，遍历所有字段组并验证字段值
    validateFields(groups) {
      for (const group of groups) {
        if (group.detail === "true") {
          for (const field of group.field_meta_info_list) {
            if (field.fieldType !== "NONE") {
              const value = group[field.id];
              if (!value) {
                this.$message({
                  message: `请填写 ${field.field_name}`,
                  type: "warning",
                });
                return false; // 有字段值为空，验证不通过
              }
            }
          }
        }
        // 递归处理子字段组
        if (group.children && group.children.length > 0) {
          const childGroups = group.children.filter(
            (child) => child.manageShow === "true"
          );
          if (childGroups.length > 0) {
            const validationPassed = this.validateFields(childGroups);
            if (!validationPassed) {
              return false; // 有子字段组验证不通过
            }
          }
        }
      }
      return true; // 所有字段验证通过
    },
    // 提交数据到后台
    async submitDataToServer(data) {
      let item = {
        close: true,
        label: "编辑员工信息",
        value: "/salesCloud/stuff/edit",
      };
      // 提交数据到服务器updateRoster
      const id = this.$route.query.id;
      console.log(data, "data");
      const res = await updateRoster(data, id);
      if (res.code === "200") {
        this.$store.commit("DEL_TAG", item);
        this.$message({
          message: "修改成功",
          type: "success",
        });
        this.$router.push({
          path: resolveUrlPath("/salesCloud/stuff"),
        });
      } else {
        this.$message({
          message: res.message ? res.message : "修改失败",
          type: "error",
        });
      }
    },

    // 克隆 result 数组
    cloneResult(result) {
      return JSON.parse(JSON.stringify(result));
    },
    // 过滤重复的对象
    filterUniqueObjects(clonedResult) {
      const uniqueIds = new Set();
      return clonedResult.filter((group) => {
        if (uniqueIds.has(group.id)) {
          return false;
        }
        uniqueIds.add(group.id);
        return true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  background-color: #f4f4f4; /* 背景色 */
  font-family: fangSong;
  font-weight: bold;
  .headerStyle {
    background-color: #fff;
    font-family: fangSong;
    font-weight: bold;
  }
}
.uploadPicture {
  display: flex;
}
.delIcon {
  width: 100px;
  height: 100px;
  // border: 1px dashed #ccc;
  border-radius: 6px;
  text-align: center;
  line-height: 100px;
  cursor: pointer;
}
.form-group {
  margin-bottom: 10px;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  .el-row {
    padding: 10px;
    .el-col-12 {
      padding: 0 10px;
    }
  }
}

.group-title {
  font-weight: bold;
  margin: 10px 0;
  color: #3569ff; /* 主色 */
}
.group-box {
  background-color: #fff;
  padding: 10px;
}
.field-text {
  margin-bottom: 5px;
}

.field-input {
  width: 100%;
  border-radius: 8px;
  background-color: #fff;
}
::v-deep .uni-select {
  background-color: #fff;
}
::v-deep .uni-date-editor {
  height: 100px;
}
::v-deep .el-cascader {
  height: 38px;
}
.add-button {
  margin-top: 5px;
  background-color: #3569ff; /* 主色 */
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #2d5bd8; /* 鼠标悬停时的颜色 */
  }
}
.page-description {
  border-bottom: #f4f4f4 solid 1px;
}
.footer-box {
  padding: 20px 0;
  text-align: center;
  background-color: #fff;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
  .submit-button {
    background-color: #3569ff; /* 主色 */
    color: #fff;
    border: none;
    width: 100%;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
      background-color: #2d5bd8; /* 鼠标悬停时的颜色 */
    }
  }
}
</style>
